(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cc-color-groups"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-color-groups')) {
    customElements.define(
      'cc-color-groups',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const pill = event.target.closest('.cc-colors__pill');
            if (!pill) return;
            this.select(pill);
          });
        }

        select(pill) {
          const value = pill.dataset.value;
          this.querySelectorAll('.cc-colors__pill').forEach((p) => p.setAttribute('aria-pressed', String(p === pill)));
          const label = this.querySelector('[data-selected-label]');
          if (label) label.textContent = value;

          if (this.dataset.mode === 'property') {
            const input = this.querySelector('[data-property-input]');
            if (input) input.value = value;
            return;
          }

          const scope = this.closest('.shopify-section') || document;
          const inputs = scope.querySelectorAll('variant-picker input[type="radio"]');
          const target = Array.from(inputs).find(
            (input) => input.dataset.optionName === this.dataset.optionName && input.value === value
          );
          if (target && !target.checked) target.click();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cc-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-personalise')) {
    customElements.define(
      'cc-personalise',
      class extends HTMLElement {
        connectedCallback() {
          this.fields = this.querySelector('[data-fields]');
          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-toggle]')) this.toggle(event.target.value === 'yes');
          });
          const text = this.querySelector('input[data-field]');
          const count = this.querySelector('[data-count]');
          if (text && count) text.addEventListener('input', () => (count.textContent = text.value.length));
        }

        toggle(on) {
          this.fields.hidden = !on;
          this.querySelectorAll('[data-field]').forEach((field) => {
            field.disabled = !on;
            if (field.tagName === 'INPUT') field.required = on;
          });
          if (on) this.querySelector('input[data-field]')?.focus();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
